/**
 * An error carrying the `errorCode` extension from an RFC 7807 ProblemDetails response.
 *
 * `getError` otherwise flattens a response down to its `detail` string, which leaves callers
 * matching on free text to identify a specific failure. The API already emits a stable
 * `errorCode` on every `MappedException`; preserving it here lets a form route a known error to
 * the field it belongs to without depending on the wording of the message.
 */
export class ApiError extends Error {
  constructor(message: string, public readonly errorCode?: string) {
    super(message);
    this.name = 'ApiError';

    // Required when targeting ES5: extending a built-in otherwise breaks `instanceof`.
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}

/** Narrows an unknown error to one carrying the given ProblemDetails `errorCode`. */
export function hasErrorCode(error: Error | null | undefined, errorCode: string): boolean {
  return error instanceof ApiError && error.errorCode === errorCode;
}
